<template>
	<div class="hp">
		<div class="col-6 intro">
			<div class="text">
				Online scan engine designed for you with love. From now on, scan your files without concerns about your files being sent to 3rd parties!
			</div>
		</div>
		<div class="col-6 icon">
			<img>		
		</div>
	</div>    
</template>

<script>
export default {    
    name: 'Home'
}
</script>